import { Typography, Stack } from '@mui/material';
import { ReactElement } from 'react';
type Props = {
  icon: ReactElement;
  title: string;
  subTitle: string | number;
  preValue: string;
};
const HeroHistoryItem = ({
  icon,
  title,
  subTitle,
  preValue
}: Props) => {
  return <Stack width='100%' direction='row' alignItems='center' bgcolor='background.bg' borderRadius='var(--corner_radius_m)' gap='var(--spacing_xs)' px='var(--spacing_m)' py='var(--spacing_xs_nudge)' data-sentry-element="Stack" data-sentry-component="HeroHistoryItem" data-sentry-source-file="HeroHistoryItem.tsx">
      <Stack width='100%' gap='var(--spacing_xs)' justifyContent='space-between' data-sentry-element="Stack" data-sentry-source-file="HeroHistoryItem.tsx">
        <Typography variant='bodyMedium__Wallfund' color='text.text' data-sentry-element="Typography" data-sentry-source-file="HeroHistoryItem.tsx">
          {title}
        </Typography>
        <Stack direction='row' alignItems='baseline' gap='var(--spacing_xs)' data-sentry-element="Stack" data-sentry-source-file="HeroHistoryItem.tsx">
          <Typography variant='titleStrong__Wallfund' color='primaryBrand.text' data-sentry-element="Typography" data-sentry-source-file="HeroHistoryItem.tsx">
            {subTitle}
          </Typography>
          <Typography variant='bodyRegular__Wallfund' color='text.text2' data-sentry-element="Typography" data-sentry-source-file="HeroHistoryItem.tsx">
            {preValue}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction='row' alignItems='center' p='var(--spacing_xs)' bgcolor='primaryBrand.bg4' height='fit-content' borderRadius='var(--corner_radius_m)' data-sentry-element="Stack" data-sentry-source-file="HeroHistoryItem.tsx">
        {icon}
      </Stack>
    </Stack>;
};
export default HeroHistoryItem;